import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import { alpha } from "@mui/material/styles";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import CalculateIcon from "@mui/icons-material/Calculate";
import LabelIcon from "@mui/icons-material/Label";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const FEATURE_CONFIG = {
  cost_control: { label: "Custo Simples", icon: CalculateIcon, color: "#059669" },
  labels: { label: "Etiquetas", icon: LabelIcon, color: "#d97706" },
  fiscal: { label: "Fiscal (NFe/NFCe)", icon: ReceiptLongIcon, color: "#7c3aed" },
  uber_direct: { label: "Uber Direct", icon: LocalShippingIcon, color: "#000" },
  auto_pilot: { label: "Auto Pilot", icon: SmartToyIcon, color: "#2563eb" },
  whatsapp: { label: "WhatsApp", icon: WhatsAppIcon, color: "#25D366" },
};

export default function FeatureAccessGrid({ features }) {
  if (!features) return null;

  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
        Funcionalidades
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "1fr 1fr 1fr" },
          gap: 1.5,
        }}
      >
        {Object.entries(FEATURE_CONFIG).map(([key, config]) => {
          const enabled = features[key] === true;
          const Icon = config.icon;

          return (
            <Box
              key={key}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                p: 1.5,
                borderRadius: 2,
                border: (theme) =>
                  `1px solid ${enabled ? alpha(config.color, 0.25) : theme.palette.divider}`,
                backgroundColor: enabled ? alpha(config.color, 0.04) : "transparent",
                opacity: enabled ? 1 : 0.55,
              }}
            >
              <Icon sx={{ fontSize: 22, color: enabled ? config.color : "grey.400" }} />
              <Typography
                variant="body2"
                sx={{ flex: 1, fontWeight: enabled ? 500 : 400 }}
              >
                {config.label}
              </Typography>
              <Chip
                size="small"
                icon={
                  enabled ? (
                    <CheckCircleIcon sx={{ fontSize: "16px !important" }} />
                  ) : (
                    <CancelIcon sx={{ fontSize: "16px !important" }} />
                  )
                }
                label={enabled ? "Ativo" : "Inativo"}
                color={enabled ? "success" : "default"}
                variant={enabled ? "filled" : "outlined"}
                sx={{ fontWeight: 600, fontSize: "0.7rem" }}
              />
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
